var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"directory-banners-gallery"}},[_c('div',{staticClass:"column-container"},[(_vm.showTimeTravel)?_c('time-travel'):_vm._e()],1),_vm._l((_vm.sections),function(section,i){return _c('gallery-section',{key:i,attrs:{"section":section,"compact":true}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }